<template lang="pug">
  LazyTheFooter(
    v-if="$i18n.locale === locale.UK"
    :isRebrand="isRebrand"
    email="")
  LazyLocalisedTheFooterUS(
    v-else-if="$i18n.locale === locale.US"
    :isRebrand="isRebrand"
    email="shipping@anyvan.com")
  LazyLocalisedTheFooterDE(
    v-else-if="$i18n.locale === locale.DE"
    :isRebrand="isRebrand"
    email="kundenservice@anyvan.de")
  LazyLocalisedTheFooterES(
    v-else-if="$i18n.locale === locale.ES"
    :isRebrand="isRebrand"
    email="info@anyvan.es")
  LazyLocalisedTheFooterFR(
    v-else-if="$i18n.locale === locale.FR"
    :isRebrand="isRebrand"
    email="info@anyvan.fr")
  LazyLocalisedTheFooterIE(
    v-else-if="$i18n.locale === 'ie'"
    :isRebrand="isRebrand"
    email="info@anyvan.ie")
  LazyLocalisedTheFooterIT(
    v-else-if="$i18n.locale === 'it'"
    :isRebrand="isRebrand"
    email="info@anyvan.it")
  LazyTheFooter(
    v-else
    :isRebrand="isRebrand"
    email="")
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { LOCALE } from "~/constants/locale"

export default defineComponent({
  name: "TheFooterContainer",
  props: {
    isRebrand: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return { locale: LOCALE }
  }
})
</script>
